module.exports = __webpack_public_path__ + "img/machine_3_2.48354a0f.jpg";